<template>
    <div class="grid grid-cols-subgrid col-span-full">
        <!-- Hover/active wash only on the header row (inset + rounded), not the whole submenu -->
        <div
            class="side-nav-item col-span-full grid grid-cols-subgrid items-center rounded-lg transition-colors group/sideNav"
            :class="[link.isActive ? 'is-active' : '']"
        >
            <SideNavigationBtnIcon :link="link" :unfold-sub-item="unfoldSubItem" />
            <SideNavigationBtnLink :link="link" :unfold-sub-item="unfoldSubItem" />
        </div>

        <template v-if="link.subItems?.length">
            <div class="col-start-1 subItemGrid overflow-hidden" :class="{ subItemsClosed: !subMenuHandler }">
                <div class="overflow-hidden flex justify-center">
                    <div class="w-px h-full bg-[var(--ui-border)] overflow-hidden" />
                </div>
            </div>

            <div class="subItemGrid overflow-hidden col-start-2" :class="{ subItemsClosed: !subMenuHandler }">
                <div class="overflow-hidden flex flex-col">
                    <SideNavigationSubmenuBtn
                        v-for="subItem in link.subItems"
                        :key="subItem.label"
                        :link="subItem"
                        :expand-sub-menu-prop="unfoldSubItem"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import type { Navigation } from '~/types/api/navigation'

const props = defineProps<{
    link: Navigation
    unfoldSubItem: boolean
}>()

const expandSubitem = ref(false)
const useIsNavClosed = useState<boolean>('isNavClosed')

provide('navItemExpandSubitem', expandSubitem)

const subMenuHandler = computed(() => props.unfoldSubItem || expandSubitem.value)

watch(useIsNavClosed, (isClosed) => {
    if (isClosed) {
        expandSubitem.value = false
    }
})
</script>

<style lang="scss" scoped>
.subItemGrid {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    transition: all 0.3s ease;
}

.subItemsClosed {
    grid-template-rows: 0fr;
}
</style>
